import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import locationsSelector from "../selectors/locationsSelector";
import MyMarker from "../components/MyMarker";
import { updateLocationState } from "../actions/map";

class LocationsContainer extends PureComponent {
  componentDidMount() {
    this.props.setCenter(this.props.locations.filter(l => !!l.lat)[0]);
  }

  render() {
    const { locations, currentLocation } = this.props;
    return locations.map((location, i) => {
      return (
        !!location.lat &&
        <MyMarker key={i} location={location} currentLocation={currentLocation} updateLocationState={this.props.updateLocationState}/>
      );
    });
  }
}

LocationsContainer.propTypes = {
  currentLocation: PropTypes.object,
  locations: PropTypes.array.isRequired,
  setCenter: PropTypes.func.isRequired,
  updateLocationState: PropTypes.func.isRequired,
};

function mapStateToProps(state, { fleetId }) {
  const locations = locationsSelector(state)[fleetId] || [];
  return {
    locations,
  };
}

export default connect(mapStateToProps, { updateLocationState })(LocationsContainer);



// WEBPACK FOOTER //
// ./src/containers/LocationsContainer.js